import * as React from 'react';

import AddLightweightProfile from 'modules/lightweight/components/AddLightweightProfile';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './discovery-creators-results-add-lightweight.scss';

applyTranslations(require('./discovery-creators-results-add-lightweight.i18n.json'));

const msgKey = 'discovery_creators_results_add_lightweight';

const DiscoveryCreatorsResultsAddLightweight = (): JSX.Element => (
  <div className="discovery-creators-results-add-lightweight">
    <div className="discovery-creators-results-add-lightweight__header">
      <div className="discovery-creators-results-add-lightweight__icon">
        <SVGDynamicIcon
          name="info-inside-circle-custom-fg"
          width={16}
          height={16}
        />
      </div>
      <div className="discovery-creators-results-add-lightweight__title">
        {__t(`${msgKey}.labels.pro_tip`)}
      </div>
    </div>
    <div className="discovery-creators-results-add-lightweight__body">
      <AddLightweightProfile />
    </div>
  </div>
);

export default DiscoveryCreatorsResultsAddLightweight;
